import { useRouter } from "next/router";
import styled from "styled-components";

import {
  DASHBOARD_DIRECTORY_BASEPATH,
  PUBLIC_DIRECTORY_BASEPATH,
} from "~/contexts/BackButtonContext/BackButtonContext";
import { VASP } from "~/types/vaspid";

const UpperRightInfoContainer = styled.div`
  display: flex;
  justify-content: right;
  a {
    color: #000;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export default function ParentGatewayInfo({ vasp }: { vasp: VASP }) {
  const router = useRouter();

  if (!vasp.parentGateway?.did) {
    return null;
  }
  return (
    <UpperRightInfoContainer>
      <a
        href="#"
        onClick={(ev) => {
          ev.stopPropagation();
          const basePath = router.pathname.includes("dashboard")
            ? DASHBOARD_DIRECTORY_BASEPATH
            : PUBLIC_DIRECTORY_BASEPATH;
          const params = new URLSearchParams({
            ...router.query,
            subsidiariesOf: String(vasp.parentGateway?.did),
          }).toString();
          const url = `${basePath}?${params}`;

          router.push(url, undefined, { shallow: true });
        }}
      >
        part of&nbsp;<strong>{vasp.parentGateway?.name}</strong>
      </a>
    </UpperRightInfoContainer>
  );
}
